import React from 'react';
import { Grid, Box, ButtonGroup, Table, Typography, TableBody } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { WhiteCard } from 'components/styles_components/card';
import { FieldsList, FieldsListItem } from 'components/styles_components/list';
import EditButton from 'components/template/button/edit';
import DeleteButton from 'components/template/button/delete';
import ShowItemTableRow from 'components/item/show_item_table_row';

const ShowItem = ({ template, space, refetch }) => {
  return (
    <WhiteCard>
      <Typography variant="h5">{template.name}</Typography>
      <Grid container direction="row" justifyContent="space-between" spacing={2}>
        <Table sx={{ mt:2, mb: 2 }}>
          <TableBody>
            <ShowItemTableRow label={<FormattedMessage id="inspection.period_cycle" />}>
              {template.periodCycle ? (
                <FormattedMessage id={`inspection.period.${template.periodCycle}`} />
              ) : (
                '-'
              )}
            </ShowItemTableRow>
            <ShowItemTableRow label={<FormattedMessage id="inspection.period_number" />}>
              {template.periodNumber ? template.periodNumber : '-'}
            </ShowItemTableRow>
            <ShowItemTableRow label={<FormattedMessage id="inspection.field.count" />}>
              {template.templateFields.length == 0 ? (
                '-'
              ) : (
                <FieldsList>
                  {template.templateFields.map((field) => {
                    return <FieldsListItem key={`template-${field.id}`}>{field.name}</FieldsListItem>;
                  })}
                </FieldsList>
              )}
            </ShowItemTableRow>
          </TableBody>
        </Table>
      </Grid>
      {space.adminRole && (
        <Grid size={{ xs: 12, lg: 6 }}>
          <Box display="flex" justifyContent="flex-end">
            <ButtonGroup variant="contained">
              <EditButton template={template} space={space} refetch={refetch} />
              <DeleteButton template={template} space={space} />
            </ButtonGroup>
          </Box>
        </Grid>
      )}
    </WhiteCard>
  );
};

export default ShowItem;
